import { create } from 'zustand'
import { applyProductTree } from '@/comm/product-tree'

/**
 * 当前用户可读的产品树（GET /products/tree 不传 scope，即各 scope 并集）与全量启用国家。
 * setTree 同时刷新 comm/app.js、comm/index.js 下的同名常量。
 */
export const useProductTreeStore = create((set) => ({
  loaded: false,
  groups: [],
  countries: [],
  setTree: (tree) => {
    const groups = Array.isArray(tree?.groups) ? tree.groups : []
    const countries = Array.isArray(tree?.countries) ? tree.countries : []
    applyProductTree({ groups, countries })
    set({ loaded: true, groups, countries })
  },
}))
